var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataProtection = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Database-Lock--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Database Lock Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.87 21.5a0.25 0.25 0 0 0 0.25 -0.25v-3a0.24 0.24 0 0 0 -0.25 -0.25c-4.33 0 -7.51 -1.15 -9.09 -2.41a0.23 0.23 0 0 0 -0.26 0 0.24 0.24 0 0 0 -0.14 0.22v1.69c0 2.32 4.51 4 9.49 4Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.38 13.45c-0.5 0 -1 0.05 -1.5 0.05 -3.51 0 -7.16 -0.83 -9.1 -2.41a0.24 0.24 0 0 0 -0.26 0 0.24 0.24 0 0 0 -0.14 0.22V13c0 2.32 4.51 4 9.49 4a0.25 0.25 0 0 0 0.25 -0.25V16a2 2 0 0 1 1.34 -1.88 0.25 0.25 0 0 0 0.17 -0.22 1.09 1.09 0 0 1 0 -0.17 0.23 0.23 0 0 0 -0.06 -0.2 0.24 0.24 0 0 0 -0.19 -0.08Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.79 9.52a0.26 0.26 0 0 0 0.33 -0.1 1.94 1.94 0 0 0 0.26 -0.92V6.79a0.25 0.25 0 0 0 -0.15 -0.23 0.25 0.25 0 0 0 -0.26 0C18 8.17 14.38 9 10.88 9s-7.16 -0.83 -9.1 -2.41a0.24 0.24 0 0 0 -0.26 0 0.24 0.24 0 0 0 -0.14 0.22V8.5c0 2.21 4.25 4 9.5 4 0.64 0 1.26 0 1.87 -0.08a0.25 0.25 0 0 0 0.21 -0.16A5 5 0 0 1 17.62 9a4.92 4.92 0 0 1 2.17 0.52Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38 4a9.5 4 0 1 0 19 0 9.5 4 0 1 0 -19 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.34 15.51a0.25 0.25 0 0 1 -0.22 -0.24v-1a3.5 3.5 0 0 0 -7 0v1a0.24 0.24 0 0 1 -0.21 0.24A1.51 1.51 0 0 0 12.62 17v5.5a1.5 1.5 0 0 0 1.5 1.5h7a1.5 1.5 0 0 0 1.5 -1.5V17a1.51 1.51 0 0 0 -1.28 -1.49Zm-4.72 4.74a1 1 0 1 1 1 1 1 1 0 0 1 -1 -1Zm-0.5 -6a1.5 1.5 0 0 1 3 0v1a0.25 0.25 0 0 1 -0.25 0.25h-2.5a0.25 0.25 0 0 1 -0.25 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataProtection);
export default ForwardRef;